import React from 'react';
import styled from 'styled-components';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import { themeColor } from '@hud/web-components/theme/colors';

export const DeltaIcon: React.FC<{ className?: string }> = styled(
  HudIcon,
).attrs({
  size: '20px',
  width: '20px',
  height: '20px',
  icon: 'other.delta',
})`
  color: ${themeColor('gray')};
  border-radius: 6px;
  background: ${themeColor('buttonBackground')};
  padding: 3px;
`;

export default function renderTrendHeader() {
  return <DeltaIcon />;
}
